import axios from "axios";

const diffingEndpoint = "api/v1/diff/diff_namespace/compare"

export function callDiffingApi(data: any) {
    const url = `${process.env.REACT_APP_SERVER_URL}/${diffingEndpoint}`;
    return axios.post(
        url,
        data,
        {
            responseType: 'text'
        }
    );
}